var _excluded = ["children", "toastRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from 'react';
import { Transition } from 'react-transition-group';
import { jsx as ___EmotionJSX } from "@emotion/core";
var ENTER_DURATION = 400;
var EXIT_DURATION = 400;
var COLLAPSE_DURATION = 150;
var ToastTransition = _ref => {
  var {
      children,
      toastRef
    } = _ref,
    transitionProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  var handleEnter = React.useCallback(() => {
    var toastNode = toastRef.current;
    if (toastNode) {
      toastNode.style.animationDuration = "".concat(ENTER_DURATION, "ms");
      toastNode.style.animationFillMode = 'forwards';
    }
  }, [toastRef]);
  var handleExited = React.useCallback(() => {
    var toastNode = toastRef.current;
    if (toastNode) {
      toastNode.removeEventListener('animationend', handleExited);
      var {
        scrollHeight: height,
        style
      } = toastNode;
      requestAnimationFrame(() => {
        style.minHeight = 'initial';
        style.height = "".concat(height, "px");
        style.transition = "all ".concat(COLLAPSE_DURATION, "ms");
        requestAnimationFrame(() => {
          style.height = '0';
          style.padding = '0';
          style.margin = '0';
        });
      });
    }
  }, [toastRef]);
  var handleExit = React.useCallback(() => {
    var toastNode = toastRef.current;
    if (toastNode) {
      toastNode.style.animationDuration = "".concat(EXIT_DURATION, "ms");
      toastNode.style.animationFillMode = 'forwards';
      toastNode.addEventListener('animationend', handleExited);
    }
  }, [handleExited, toastRef]);
  return ___EmotionJSX(Transition, _extends({
    timeout: {
      enter: ENTER_DURATION,
      exit: EXIT_DURATION + COLLAPSE_DURATION
    },
    unmountOnExit: true,
    onEnter: handleEnter,
    onExit: handleExit
  }, transitionProps), children);
};
ToastTransition.displayName = 'ToastTransition';
export default ToastTransition;